export const useHelpConfig = () => {
  const HELP_PAGE_MAP = {
    prod1: {
      En: {
        learner_understandingData: '4410819490066-Understanding-the-data',
        teacher_understandingData: '4410743080210-Understanding-the-data',
        learner_practiceTestScores:
          '4411089956882-Understanding-your-Test-Train-Timed-Practice-Test-scores',
        teacher_practiceTestScores:
          '4410612486162-Understanding-Test-Train-Timed-Practice-Test-scores',
        teacher_understandingCodesAndKeys:
          '19767349810322-What-is-the-difference-between-activation-codes-class-keys-and-school-keys',
        teacher_activatingCourseMaterials:
          '13444112644498-How-do-I-activate-my-teaching-materials-on-Cambridge-One',
        teacher_creatingClass: '4410631715346-How-do-I-create-a-class',
        teacher_addingStudentsToClass:
          '4410612035602-How-do-I-add-adult-students-to-a-class',
        teacher_creatingAssignments:
          '4410612256274-How-do-I-set-homework-assignments-on-Cambridge-One',
        ielts: '4410106166930-IELTS-Intelligence',
        requests: 'new',
        learner_activateCodeHelp:
          '4410617478546-How-do-I-activate-my-learning-materials-on-Cambridge-One'
      },
      Es: {
        learner_understandingData: '4410819490066-Interpretación-de-los-datos',
        learner_activateCodeHelp:
          '4410617478546--Cómo-activo-mis-materiales-de-aprendizaje'
      }
    },
    default: {
      En: {
        learner_understandingData: '4410848542226-Understanding-the-data',
        teacher_understandingData: '4405381750162-Understanding-the-data',
        learner_practiceTestScores:
          '4411124450194-Understanding-your-Test-Train-Timed-Practice-Test-scores',
        teacher_practiceTestScores:
          '4405380464274-Understanding-your-Test-Train-Timed-Practice-Test-scores',
        teacher_understandingCodesAndKeys:
          '20391916463634-What-is-the-difference-between-an-activation-code-class-key-and-school-key',
        teacher_activatingCourseMaterials:
          '17760467863186-How-do-I-activate-my-teaching-materials-on-Cambridge-One',
        teacher_creatingClass: '4405381295890-How-do-I-create-a-class',
        teacher_addingStudentsToClass:
          '4405387421714-How-do-I-add-adult-students-to-a-class',
        teacher_creatingAssignments:
          '4405387512466-How-do-I-set-homework-assignments-on-Cambridge-One',
        ielts: '4407581188498-IELTS-Intelligence',
        requests: 'new',
        learner_activateCodeHelp:
          '4405379928082-How-do-I-activate-my-learning-materials-on-Cambridge-One'
      },
      Es: {
        learner_understandingData: '4410848542226-Interpretación-de-los-datos',
        learner_activateCodeHelp:
          '4405379928082--Cómo-activo-mis-materiales-de-aprendizaje'
      }
    }
  };

  /* Get the Help Page property */
  const getHelpPagePath = (
    environment: string,
    category?: string,
    article?: string,
    language = 'En'
  ) => {
    const config = useRuntimeConfig().public;
    let helpPagePath =
      language === 'Es' ? config.zendeskBasePathES : config.zendeskBasePathEN;

    if (article && article == 'activatingCourseMaterials') {
      helpPagePath = config.zendeskBasePathEN;
    }

    if (!category) {
      return helpPagePath;
    }

    // @ts-ignore
    const helpPageMap = HELP_PAGE_MAP[environment] || HELP_PAGE_MAP.default;

    const getArticlePath = (
      category: string,
      article: string,
      language: string
    ) => {
      const key = `${category}_${article}`;
      if (helpPageMap[language]?.[key]) {
        return `/articles/${helpPageMap[language][key]}`;
      }
      return `/articles/${helpPageMap['En'][key]}`;
    };

    const getCategoryPath = (category: string, language: string) => {
      if (helpPageMap[language]?.[category]) {
        return category === 'requests'
          ? `/requests/${helpPageMap[language][category]}`
          : `/categories/${helpPageMap[language][category]}`;
      }
      return category === 'requests'
        ? `/requests/${helpPageMap['En'][category]}`
        : `/categories/${helpPageMap['En'][category]}`;
    };

    return article
      ? helpPagePath + getArticlePath(category, article, language)
      : helpPagePath + getCategoryPath(category, language);
  };

  return { getHelpPagePath };
};
